import styled from 'styled-components';
export var DayName = styled.div.withConfig({
  displayName: "elements__DayName",
  componentId: "ywg3ab-0"
})(["display:flex;flex-basis:2.8rem;justify-content:center;height:1.1rem;width:2.8rem;user-select:none;&:not(:nth-child(7n)){margin-right:0.8rem;}font-size:", ";text-transform:uppercase;color:", ";"], function (_ref) {
  var size = _ref.theme.fonts.size;
  return "calc(".concat(size["default"], " - 0.2rem)");
}, function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.spaceGrey;
});